var $f80be5fd4d03dda9$exports = require("./LocalizedStringDictionary.main.js");
var $3e95fbf3429967d1$exports = require("./LocalizedStringFormatter.main.js");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "LocalizedStringDictionary", () => $f80be5fd4d03dda9$exports.LocalizedStringDictionary);
$parcel$export(module.exports, "LocalizedStringFormatter", () => $3e95fbf3429967d1$exports.LocalizedStringFormatter);
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



//# sourceMappingURL=main.js.map
